<ng-container *ngIf="entityType == 'EKAMPUS'">
  <app-loginEkampus></app-loginEkampus>
</ng-container>
<ng-container *ngIf="entityType == 'IP'">
  <app-loginIP></app-loginIP>
</ng-container>
